import React, { useState } from 'react'
import ReactSimplyCarousel from 'react-simply-carousel'
import PropTypes from 'prop-types'

const Carousel = ({ children, ...props }) => {
  const [activeSlide, setActiveSlide] = useState(0)

  const carouselProps = {
    activeSlideIndex: activeSlide,
    onRequestChange: setActiveSlide,
    ...props
  }

  return <ReactSimplyCarousel {...carouselProps}>{children}</ReactSimplyCarousel>
}

Carousel.propTypes = {
  children: PropTypes.node
}

export default Carousel
